import { decodeEntities } from '../helpers/stringHelpers'

const imageModel = ({ uuid, label, versionAndPublicId, size }) => versionAndPublicId
  ? ({
      uuid,
      title: decodeEntities(label),
      publicId: versionAndPublicId,
      size
    })
  : null

export default imageModel
